import './checkout-transit-order.scss';

import type { NavigateTo } from '@core/app/scripts/services/navigate-to';
import { Broadcaster } from '@core/app/scripts/services/broadcaster';
import { CurrentSession } from '@shared/app/scripts/services/current-session';
import { DisplayMessage } from '@core/app/scripts/services/display-message';
import { EndOfShift } from '@pos/app/scripts/services/end-of-shift';
import { Mask } from '@core/app/scripts/services/mask';
import { PosSearch } from '@pos/app/scripts/services/pos-search';
import { SalesCalculations } from '@shared/app/scripts/services/sales-calculations';
import { Transit } from '@shared/app/scripts/services/transit';

const { of } = require('rxjs');

/*
 * Component responsible for /checkout-transit-order route.
 */
angular
  .module('posApp')
  .directive(
    'checkoutTransitOrder',
    (
      broadcaster: Broadcaster,
      currentSession: CurrentSession,
      displayMessage: DisplayMessage,
      endOfShift: EndOfShift,
      legacyPrint,
      mask: Mask,
      navigateTo: NavigateTo,
      parser,
      pos,
      posInit,
      posSearch: PosSearch,
      salesCalculations: SalesCalculations,
      sentry,
      transit: Transit,
      transitOrderInfo,
      translate: ng.translate.ITranslateService,
    ) => ({
      restrict: 'E',

      scope: true,

      template: require('./checkout-transit-order.html').default,

      link: function ($scope, element, attrs) {
        const $translate = translate;

        $scope.pos = pos;

        $scope.inputValue = '';
        $scope.enableAmount = false;

        $scope.searchFocus$ = of(undefined);

        broadcaster.send('windowResized');

        $scope.navigateToView = (view) => {
          navigateTo(view);
        };

        $scope.search = (searchInput) => {
          $scope.searchInput = '';

          // TODO find more precise method to be called form here
          posSearch.scan(searchInput);
        };

        $scope.onChangeCashier = () => {
          return;
        };

        $scope.onKeyPress = (val) => {
          pos.key(val, $scope);
          return;
        };

        // search article from article list
        $scope.onArticleSearch = () => {
          // goto article list
          posInit.pageRef = 'pos.route#checkout-transit-order';
          navigateTo('pos.route#article');
        };

        // change number of articles
        $scope.onChangeQty = () => {
          $scope.inputValue = '';
          $scope.enableAmount = true;
          broadcaster.send('setFocus', 'transit-amount-input');
        };

        // Change the Qty of a line
        $scope.editLine = (lineIndex) => {
          if (pos.transaction.receipt[lineIndex]) {
            pos.transaction.selectedLine = lineIndex;
            $scope.inputValue = String(pos.transaction.receipt[lineIndex].qty);
            $scope.enableAmount = true;
            broadcaster.send('setFocus', 'transit-amount-input');
          }
        };

        // process number of articles
        $scope.procQty = () => {
          if (!$scope.inputValue) {
            $scope.inputValue = '';
          }
          const newval = $scope.inputValue.replace(',', '.');
          try {
            $scope.inputValue = parser.evaluate(newval);
          } catch (err) {
            displayMessage.message($translate.instant('IncorrectEntry'));
            return;
          }

          if ($scope.inputValue > 99999) {
            displayMessage.message(
              $translate.instant('Maximum Input Exceeded'),
            );
            return;
          } else if ($scope.inputValue < 0) {
            displayMessage.message($translate.instant('Negative Not Allowed'));
            return;
          }

          if (!$scope.transitAmountEntryForm.$valid) {
            displayMessage.message($translate.instant('IncorrectEntry'));
            return;
          }

          pos.transaction.totalNumber -=
            pos.transaction.receipt[pos.transaction.selectedLine].qty;
          pos.transaction.receipt[pos.transaction.selectedLine].qty = parseInt(
            $scope.inputValue,
          );
          pos.transaction.totalNumber +=
            pos.transaction.receipt[pos.transaction.selectedLine].qty;

          $scope.inputValue = '';
          $scope.enableAmount = false;
        };

        $scope.toggleRemarkField = () => {
          //User should not change cashier when receipt is being processed
          $scope.remark = $scope.remark ? false : true;
          broadcaster.send('setFocus', 'transitRemark');
        };

        $scope.resetTransit = () => {
          pos.resetTransaction('transit');

          $scope.inputValue = '';
          $scope.enableAmount = false;

          // goto pos
          pos.selectedMenu = 1;
          navigateTo('pos.route#main');
        };

        $scope.print = () => {
          if (pos.transaction.receipt.length === 0) {
            const message = $translate.instant('ScanAnArticle');
            displayMessage.message(message);
          } else {
            displayMessage.showLoading();

            transit.startNew().then((transaction) => {
              transaction.receipt = pos.transaction.receipt;
              transaction.transit = pos.transaction.transit;
              transaction.remark = pos.transaction.remark;

              salesCalculations.updateTotals(transaction);

              pos.setCashier(transaction, pos.config.selectedCashier);

              legacyPrint
                .transitOrder({
                  transactions: transaction,
                  config: pos.config,
                  send: true,
                })
                .then(angular.noop, () => {
                  displayMessage.message(
                    $translate.instant('PrintingNotPossible'),
                  );

                  sentry.captureMessage('Failed to print transit', {
                    extra: { transaction: transaction },
                  });
                });

              //  Send transit order to the server
              let postData;

              if (transitOrderInfo.direction == 'to') {
                postData =
                  'from__' +
                  pos.config.cashregisterNr +
                  '/to__' +
                  transitOrderInfo.warehouseId;
              } else {
                postData =
                  'to__' +
                  pos.config.cashregisterNr +
                  '/from__' +
                  transitOrderInfo.warehouseId;
              }

              //Add the transit refid
              postData += '/refid__' + pos.transaction.nr;
              //Add the transit barcodes
              postData += '/barcodes__';
              let firstBC = true;
              for (const line in transaction.receipt) {
                if (transaction.receipt[line]) {
                  if (firstBC) {
                    firstBC = false;
                  } else {
                    postData += ',';
                  }

                  postData +=
                    transaction.receipt[line].barcode +
                    ':' +
                    transaction.receipt[line].qty;
                }
              }

              //Add transaction number and other transit
              transaction.device = currentSession.userId;

              // link the shift if EOS is used, store receipt in the spynl api
              endOfShift.setShiftCycleId(transaction);

              transit.add(transaction).then(
                () => {
                  $scope.resetTransit();
                  mask.hide();
                },
                (error) => {
                  mask.hide();
                  displayMessage.message($translate.instant('SavingFailed'));
                  sentry.captureMessage('Failed to save transit', {
                    extra: { transaction },
                  });
                },
              );
            });
          }
        };
      },
    }),
  );
